import React from "react";
import PropTypes from "prop-types";
// import { accountType } from "custom-prop-types";
import styles from "components/settings/settings-menus.scss";
import { Link } from "react-router";

export const UserSettingsMenu = ({ slug }) => (
  <div className={ styles.menu }>
    <ul>
      { renderMenuLinks(slug, "info", "Name and Email") }
      { renderMenuLinks(slug, "password", "Change Password") }
      {/* { renderFavouriteAccount(accounts, slug) } */}
      { renderUISettingsPage(slug) }
    </ul>
  </div>
);

UserSettingsMenu.propTypes = {
  // accounts: PropTypes.arrayOf(accountType).isRequired,
  slug: PropTypes.string.isRequired
};

const renderMenuLinks = (slug, path, title) => (
  <Link
    activeClassName={ styles["active-menu-item"] }
    to={ `/accounts/${slug}/settings/user/${path}` }
  >
    <li>{ title }</li>
  </Link>
);

const renderUISettingsPage = (slug) => {
  if (OAUTH_CLIENT_ID === "SQRLST_WEB_APP_NEWUI_BETA") {
    return null;
  }
  return renderMenuLinks(slug, "ui-settings", "UI Settings");
};

// const renderFavouriteAccount = (accounts, slug) => {
//   if (accounts.length < 2) {
//     return null;
//   }
//   return renderMenuLinks(slug, "favourite-account", "Set Favourite Account");
// };



// WEBPACK FOOTER //
// ./src/js/components/settings/user-settings-menu.jsx